import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	similarWorkItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	similarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.similar-work-items',
		defaultMessage: 'Similar work items',
		description: 'Title of the collapsible parent',
	},
});
export default messages;
